import { Container, Row, Col } from "react-bootstrap";

export default function ContentPage({ embedded = false }) {
  const Wrapper = ({ children }) =>
    embedded ? (
      <div className="p-3">{children}</div>
    ) : (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-8">
            <div className="p-5 rounded shadow-sm">{children}</div>
          </div>
        </div>
      </div>
    );
  return (
    // <Container className="py-5">
    //   <Row className="justify-content-center">
    //     <Col lg={10} xl={8}>
    //       <div className="p-5 rounded shadow-sm">
    <Wrapper>
      {/* Page Title */}
      <div className="section-title mb-4">
        <h1 style={{ fontSize: "30px" }}>Triniti Organics</h1>
      </div>

      {/* Intro */}
      <section className="mb-5">
        <p>
          <strong>TRINITI Organics</strong> is a premium organic, plant-forward food company positioned at the intersection of health, convenience, and global culinary inspiration.
        </p>
        <p>
          Its signature platform — <strong>Blue Zone Meals: "Just Add Rice or Pasta"</strong> — delivers globally inspired, shelf-stable organic meal bases rooted in longevity-driven dietary principles.
        </p>
      </section>

      {/* Core Flavor Platforms */}
      <section className="mb-5">
        <div className="section-title">
          <h2>Core Flavor Platforms</h2>
        </div>
        <ul className="ms-4">
          <li className="mb-2">
            <strong>Mediterranean</strong> – Chickpeas, Tomato, Red Peppers
          </li>
          <li className="mb-2">
            <strong>Asia</strong> – Edamame, Mushrooms, Cabbage
          </li>
          <li>
            <strong>Central America</strong> – Black Beans, Squash, Corn
          </li>
        </ul>
        <p>
          The brand aligns strongly with:
        </p>
        <ul className="ms-4">
          <li>Organic & clean-label demand</li>
          <li>Plant-based protein growth</li>
          <li>Convenient meal assembly</li>
          <li>Health-conscious millennial households</li>
        </ul>
      </section>

      {/* Market Positioning */}
      <section className="mb-5">
        <div className="section-title">
          <h2>Market Positioning & Tailwinds</h2>
        </div>
        <p>
          TRINITI operates in a structurally growing category:
        </p>
        <ul className="ms-4">
          <li>94M American adults purchased organic foods</li>
          <li>Organic category CAGR: 9.4%</li>
          <li>76% purchase organic for health reasons</li>
          <li>62% would buy organic if more affordable</li>
          <li>Organics account for just 4% of total food sales</li>
        </ul>
        <p>
          <strong>Implication:</strong> Significant runway remains for organic penetration growth.
        </p>
      </section>

      {/* Business Performance Highlights */}
      <section className="mb-5">
        <div className="section-title">
          <h2>Business Performance Highlights</h2>
        </div>
        
        <div className="mb-4">
          <h3>1️⃣ Strong Category Alignment</h3>
          <p>
            TRINITI is positioned within:
          </p>
          <ul className="ms-4">
            <li>High-growth organic food</li>
            <li>Shelf-stable plant-based protein</li>
            <li>Globally inspired meal kits</li>
            <li>Affordable convenience segment</li>
          </ul>
          <p>
            This positioning places the company in a resilient segment that performs well across economic cycles due to its value-to-nutrition ratio.
          </p>
        </div>

        <div className="mb-4">
          <h3>2️⃣ Velocity-Driven Retail Model</h3>
          <p>
            The brand's performance framework emphasizes:
          </p>
          <ul className="ms-4">
            <li>Distribution expansion (Numeric & Weighted Distribution)</li>
            <li>Store-level productivity (Sales per Store per Week)</li>
            <li>Promotional lift tracking</li>
            <li>Inventory turnover efficiency</li>
          </ul>
          <p>
            The business model prioritizes:
          </p>
          <p>
            <strong>Deep performance in existing accounts before broad geographic expansion.</strong>
          </p>
        </div>

        <div className="mb-4">
          <h3>3️⃣ Omnichannel Readiness</h3>
          <p>
            Industry data shows:
          </p>
          <ul className="ms-4">
            <li>82–87% of grocery purchases still occur in-store</li>
            <li>Loyalty programs and digital coupons significantly influence purchase decisions</li>
            <li>Online grocery is growing toward mid-teens share in coming years</li>
          </ul>
          <p>
            TRINITI is structurally positioned to benefit from:
          </p>
          <ul className="ms-4">
            <li>In-store shelf visibility</li>
            <li>Digital coupon integration</li>
            <li>Retailer loyalty engagement</li>
            <li>Online shelf optimization</li>
          </ul>
          <p>
            Retail exposure includes natural and premium grocery environments such as:
          </p>
          <ul className="ms-4">
            <li>Wegman's</li>
            <li>Whole Foods</li>
          </ul>
          <p>
            These channels reinforce TRINITI's premium-organic brand equity positioning.
          </p>
        </div>

        <div className="mb-4">
          <h3>4️⃣ Margin & Risk Considerations</h3>
          <p>
            Key performance sensitivities include:
          </p>
          <ul className="ms-4">
            <li>Raw material inflation</li>
            <li>Promotional dependency</li>
            <li>Competitive private label pressure</li>
            <li>Supply chain disruptions</li>
          </ul>
          <p>
            However, the shelf-stable format provides:
          </p>
          <ul className="ms-4">
            <li>Lower spoilage risk</li>
            <li>Strong inventory efficiency</li>
            <li>Extended shelf life</li>
            <li>Improved working capital management</li>
          </ul>
        </div>
      </section>

      {/* Competitive Advantage */}
      <section className="mb-5">
        <div className="section-title">
          <h2>Competitive Advantage</h2>
        </div>
        <p>
          TRINITI differentiates through:
        </p>
        <ul className="ms-4">
          <li>Blue Zone longevity positioning</li>
          <li>Cultural authenticity in flavor platforms</li>
          <li>Organic + plant protein blend</li>
          <li>Simple preparation model ("Just Add Rice or Pasta")</li>
          <li>Strong alignment with millennial family households</li>
        </ul>
        <p>
          This creates a defendable niche between:
        </p>
        <ul className="ms-4">
          <li>Generic canned vegetables</li>
          <li>Frozen meals</li>
          <li>Premium refrigerated prepared foods</li>
        </ul>
      </section>

      {/* Analyst Outlook */}
      <section>
        <div className="section-title">
          <h2>Analyst Outlook</h2>
        </div>
        <p>
          <strong>Near-Term Outlook:</strong> Positive, with growth tied to distribution scaling and sustained velocity performance.
        </p>
        <p>
          <strong>Medium-Term Growth Drivers:</strong>
        </p>
        <ul className="ms-4">
          <li>Geographic expansion</li>
          <li>Affordability strategy</li>
          <li>Increased loyalty penetration</li>
          <li>Occasion-based marketing (winter comfort meals, plant-based January, etc.)</li>
        </ul>
        <p>
          <strong>Long-Term Potential:</strong> High — if TRINITI establishes itself as:
        </p>
        <p>
          The leading organic, globally inspired, shelf-stable meal base brand in natural grocery.
        </p>
        <p>
          The company's structural alignment with organic growth trends, plant-based consumption, and convenience-driven purchasing behavior positions it well for sustainable growth within the premium CPG segment.
        </p>
      </section>
    </Wrapper>
  );
}
